import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

export default class Ac2WarehouseProvider extends HttpRequest {
  getAc2Warehouses (query) {
    this.setHeader(getAuthToken())
    return this.get('/ac2/warehouses', query)
  }

  resolveAc2Warehouse (warehouse) {
    this.setHeader(getAuthToken())
    return this.get('/ac2/warehouses/resolve', { warehouse })
  }

  getWmsManaged (query) {
    this.setHeader(getAuthToken())
    return this.get('/ac2/warehouses/wms-managed', query)
  }

  getAc2WarehouseById (id) {
    this.setHeader(getAuthToken())
    return this.get(`/ac2/warehouses/${id}`)
  }

  createAc2Warehouse (payload) {
    this.setHeader(getAuthToken())
    return this.post('/ac2/warehouses', payload)
  }

  updateAc2WarehouseById (id, payload) {
    this.setHeader(getAuthToken())
    return this.patch(`/ac2/warehouses/${id}`, payload)
  }

  deleteAc2WarehouseById (id) {
    this.setHeader(getAuthToken())
    return this.remove(`/ac2/warehouses/${id}`)
  }
}
